import { useRoutes, useNavigate } from "react-router-dom";
import Themeroutes from "./routes";
import { useEffect } from "react";
import instance from "./utils/apiUtils";
import { useDispatch } from "react-redux";
import { loginAction, logoutAction } from "./store/actions/userActions";
import { getAccount } from "./services/authService";
import { getGroupByUser } from "./services/groupsService";

const App = () => {
  const navigate = useNavigate();
  const routing = useRoutes(Themeroutes);
  const dispatch = useDispatch();

  useEffect(async () => {
    try {
      const storedToken = localStorage.getItem("bearerToken");

      if (storedToken) {
        // Set Authorization header for API requests
        instance.defaults.headers["Authorization"] = `Bearer ${storedToken}`;
        const userResponse = await getAccount();

        const isAdmin =
          userResponse.authorities.includes("ROLE_ADMIN") || false;
        const groupResponse = await getGroupByUser(userResponse.id);
        // Dispatch login action with stored user data

        dispatch(
          loginAction({
            user: userResponse,
            isAdmin: isAdmin,
            group: groupResponse?.group,
          })
        );
      } else {
        navigate("/login");
      }
    } catch (error) { 
      localStorage.removeItem("bearerToken");
      dispatch(logoutAction());
      navigate("/login");
    }
  }, []);

  return <>{routing}</>;
};

export default App;
